// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {defineStore, storeToRefs} from 'pinia'
import {config} from "@/core/config";
import {SmartSearchConfig} from "@/main";
import {ProductInterface} from "@/core/types";
import {SanitizeValue} from "@/core/utils";

import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {searchLogger, searchErrorLogger} from "@/core/Logger";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useTitleStore} from "@/store/TitleStore";

const {apiHost, customerSymbol, searchId, apiKey} = config


export const useSerpResultsStore = defineStore('SerpResultsStore', {
  state: () => {
    return {
      products: [] as ProductInterface[],
      currency: {
        code: 'PLN',
        symbol: 'zł'
      },
      filters: {},
      price: {},
      sort: '',
      query: '',
      total: 0,
      page: 0,
      totalPage: null,
      loading: false,
      initialised: false,
    }
  },
  getters: {
    getProducts(state): Array<ProductInterface> {
      return state.products
    },
    getCurrencyCode(state): string {
      return state.currency.code
    },
    getProductsCount(state): number {
      return state.products.length
    },
    noProductsToDisplay(state): boolean {
      return state.products.length === 0
    },
    getTotalProducts(state): number {
      return state.total
    },
    noResultsState(state): boolean {
      return state.products.length === 0 && state.query
    },
    typeQueryState(state): boolean {
      const {allowEmptyQuery} = SmartSearchConfig.value.serp.query
      return !state.loading && !allowEmptyQuery && !state.query
    }
    
  },
  actions: {
    getSearchQueryParams(url: URL): URL {
      const urlParams = useSearchQueryStore().getSearchParams()
      const searchQuery = SanitizeValue(useSearchQueryStore().getSearchQuery)
      
      const sortingStore = useSortingStore()
      const paginationStore = usePaginationStore()
      const page = paginationStore.getSelectedPageFromUrl()
      
      page !== 0 && url.searchParams.set('p', page)
      
      searchLogger.log(`getSearchQueryParams page.value: ${page}`)
      
      urlParams.forEach((value, key) => {
        if (key.match(/^f/)) {
          url.searchParams.set(key, value);
        }
      });
      searchQuery && url.searchParams.set('q', searchQuery)
      url.searchParams.set('s', sortingStore.getSelectedSortFromUrl())
      return url
    },
    
    
    async getAndSetProducts(from = 'unknown'): Promise<void> {
      searchLogger.log(`getAndSetProducts: ${from}`)
      const {allowEmptyQuery} = SmartSearchConfig.value.serp.query
      const searchQuery = useSearchQueryStore().getSearchQuery
      
      if (!allowEmptyQuery && !searchQuery) {
        searchLogger.log('Not allowed to show results on empty query')
        return
      }
      
      let url = new URL(`https://${apiHost}/restapi/${customerSymbol}/search/${searchId}/products`)
      url = this.getSearchQueryParams(new URL(url))
      
      searchLogger.log(`getAndSetProducts url: ${url.toString()}`)
      const config = {
        headers: {
          'Api-key': apiKey
        },
        credentials: 'include'
      }
      
      try {
        this.loading = true
        const response = await fetch(
          `${url.toString()}`,
          config
        );
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const {products, meta} = await response.json();
        
        const {filters, price, sort, total, totalPage, page, query, currency} = meta
        
        this.actualizeFiltersStore(filters)
        this.actualizePaginationStore(page, totalPage)
        this.actualizeDocumentTitle(query, total)
        
        Object.assign(this, {products, query, filters, price, sort, total, currency});
        this.loading = false
        
      } catch (error) {
        this.loading = false
        searchErrorLogger.log('Error fetching filters:', error);
      }
    },
    
    actualizeFiltersStore(filters) {
      const filtersStore = useFiltersStore();
      filtersStore.setActiveFilters(filters)
      
    },
    actualizePaginationStore(newPage, newTotalPage) {
      const paginationStore = usePaginationStore();
      const {page, totalPage} = storeToRefs(paginationStore)
      
      page.value = newPage
      totalPage.value = newTotalPage
      
    },
    actualizeDocumentTitle(query, total) {
      useTitleStore().changeTitle(query, total)
    },
    scrollIntoView() {
      document.getElementById("smartsearch-serp").scrollIntoView({behavior: 'auto'});
    }
  },
})
